import "./Style/loader.css";

const CartLoaderIcon = () => {
    return (
        <div className="flex flex-col items-center justify-center h-full">
            <div className="lds-default">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default CartLoaderIcon;